import { jsx as _jsx } from "react/jsx-runtime";
import dodecahedronUrl from '../../../assets/gems/dodecahedron.svg?inline';
export function Dodecahedron({ ...props }) {
    return _jsx("img", { ...props, src: dodecahedronUrl, alt: 'DodecahedronImage' });
}
